export const locales = ['en', 'de', 'it', 'fr', 'es', 'ja'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'en';

/** Technical terms that remain English in all locales. */
export const UNTRANSLATED_TERMS = [
  'Workspace',
  'Project',
  'Remix',
  'Deploy',
  'Publish',
  'Preview',
  'Repository',
  'Commit',
  'Branch',
  'API',
  'SDK',
  'Token',
  'Webhook',
  'OAuth',
  'SSO',
  'SCIM',
  'ZenOpus',
  'Agent',
  'Chat',
  'Plan',
  'Visual Edits',
  'Glassmorphism',
  'Aurora Gradient',
  '3D Depth',
  'Liquid Organic',
  'Neumorphism',
  'Gradient Glow',
  'Dark Minimal',
  'Clean Minimal Light',
  'Material 3',
  'iOS-Inspired Clean',
  'Soft & Colorful',
  'Bold Dark',
] as const;
